import { HoldMusicService } from '@weave/schema-gen-ts/dist/schemas/phone/hold-music/v1/hold_music_service.pb';
import { bindHTTP } from '@frontend/schema';

const SchemaHoldMusicService = bindHTTP(HoldMusicService);

export default SchemaHoldMusicService;
